import { useIsExistingCustomer } from 'hooks/common/use-is-existing-customer';
import { EffectiveCart } from 'interfaces/cart';
import { PriceSummary } from 'modules/price-summary';
import { usePriceSummaryConfig } from 'modules/price-summary/use-price-summary-config';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSavingPlanStore } from 'stores/saving-plan';

interface Props {
  containsPreorderItem: boolean;
  containsPreorderItemsOnly: boolean;
  effectiveCart: EffectiveCart;
}

export const CheckoutPriceSummary: FC<Props> = ({
  containsPreorderItem,
  containsPreorderItemsOnly,
  effectiveCart,
}) => {
  const activePlan = useSavingPlanStore((state) => state.activePlan);
  const { isEc: isExistingCustomer } = useIsExistingCustomer();
  const priceSummaryConfig = usePriceSummaryConfig({
    config: {
      isExistingCustomer,
      shouldShowFreeShippingNotice: false,
      shouldShowMinimumBasketNotice: false,
    },
    effectiveCart,
    isInCheckout: true,
  });

  return (
    <div className="px-6 py-4" data-test="checkout-price-summary">
      {containsPreorderItem && (
        <h2 className="mb-3 font-medium text-red-600" data-test="checkout-preorder-notice">
          <FormattedMessage
            id={
              containsPreorderItemsOnly
                ? 'cart:preorder-only-shipping-delay'
                : 'cart:preorder-mixed-shipping-delay'
            }
          />
        </h2>
      )}

      <PriceSummary
        activePlan={activePlan}
        config={priceSummaryConfig}
        effectiveCart={effectiveCart}
      />
    </div>
  );
};
